import { jsx as _jsx } from "react/jsx-runtime";
import MuiSnackbar from '@mui/material/Snackbar';
import * as React from 'react';
import { withVersion } from '../utils';
const SnackbarImpl = (props) => _jsx(MuiSnackbar, { ...props });
export const Snackbar = withVersion(SnackbarImpl, '1.0.0');
